__turbopack_context__.v({
  "className": "nunito_sans_f237e783-module__gjWrLW__className",
});
